import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {AbstractBffApi} from '../models/sharedinterface';
import {ShareddataService} from '../shared/services/shareddata.service';
import {ApiFactoryService} from '../shared/services/api-factory.service';
import {GlobalsService} from '../shared/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class RouteadminguardGuard implements CanActivate {

  isloggedin: boolean;

  bffapi: AbstractBffApi;

  constructor(
    private authservice: AuthenticationService,
    private shareddata: ShareddataService,
    private router: Router,
    private apifactory: ApiFactoryService,
    private globalsservice: GlobalsService
  ) {
    this.bffapi = this.apifactory.createBffApi();
    this.authservice.isloggedin$.subscribe((data) => {
      this.isloggedin = data;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Mandatory in routeguard to check also localsession independantly of shared variables
    this.authservice.checkLocalSession();

    if (this.isloggedin) {
      // Recheck remote session
      const query = this.bffapi.checkuser();
      query.subscribe((response) => {
        const roles = response.results.roles;

        this.shareddata.setUserroles(roles);
        this.authservice.setLoggedin(true);

        // Redirect non admin user to the homepage
        if (!this.globalsservice.isAmongRoles(['ROLE_ADMIN'], roles)) {
          this.router.navigate(['']);
        } // if

      });
    } else {
      this.authservice.setLoggedin(false);
      this.router.navigate(['']);
    }

    return true;
  }

}
